import { z } from "zod";

export const RootSearchSchema = z.object({
    redirect_url: z.string().optional(),
});
